
/* ======================================================
   SPACE AVAILABLE — COLLECTION GRID V2
   JavaScript

   01 — Collection Initialization
   02 — Dynamic Sorting
   03 — Shopify Theme Editor
   ====================================================== */

(() => {
  'use strict';


  /* ==============================================
     01 — INITIALIZE COLLECTION
     ============================================== */

  const setupCollection = (collection) => {

    if (!collection) return;

    const sortForm = collection.querySelector(
      '[data-sa-sort-form]'
    );

    if (!sortForm) return;

    if (sortForm.dataset.saSortReady === 'true') {
      return;
    }

    const sortSelect = sortForm.querySelector(
      '[data-sa-sort]'
    );

    if (!sortSelect) return;

    sortForm.dataset.saSortReady = 'true';
    sortForm.classList.add('is-enhanced');


    /* ==========================================
       02 — COLLECTION SORTING
       ========================================== */

    sortSelect.addEventListener('change', () => {

      const url = new URL(
        window.location.href
      );

      const selectedSort = sortSelect.value;

      if (selectedSort) {

        url.searchParams.set(
          'sort_by',
          selectedSort
        );

      } else {

        url.searchParams.delete('sort_by');

      }

      /* Return to first page when sorting */

      url.searchParams.delete('page');

      window.location.assign(
        url.toString()
      );

    });

  };


  /* ==============================================
     03 — INITIALIZE ALL SECTIONS
     ============================================== */

  const init = (container = document) => {

    if (
      container.matches &&
      container.matches('[data-sa-collection]')
    ) {

      setupCollection(container);

    }

    container
      .querySelectorAll('[data-sa-collection]')
      .forEach(setupCollection);

  };


  /* ==============================================
     04 — DOCUMENT READY
     ============================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );

  } else {

    init();

  }


  /* ==============================================
     05 — SHOPIFY THEME EDITOR
     ============================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      init(event.target);

    }
  );

})();
